/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SiegeSocialFichierGridDto } from './SiegeSocialFichierGridDto';
import {
    SiegeSocialFichierGridDtoFromJSON,
    SiegeSocialFichierGridDtoFromJSONTyped,
    SiegeSocialFichierGridDtoToJSON,
} from './SiegeSocialFichierGridDto';

/**
 * 
 * @export
 * @interface SiegeSocialFichierGridDtoPaginatedResults
 */
export interface SiegeSocialFichierGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialFichierGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SiegeSocialFichierGridDto>}
     * @memberof SiegeSocialFichierGridDtoPaginatedResults
     */
    results?: Array<SiegeSocialFichierGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SiegeSocialFichierGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SiegeSocialFichierGridDtoPaginatedResults interface.
 */
export function instanceOfSiegeSocialFichierGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeSocialFichierGridDtoPaginatedResultsFromJSON(json: any): SiegeSocialFichierGridDtoPaginatedResults {
    return SiegeSocialFichierGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SiegeSocialFichierGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeSocialFichierGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SiegeSocialFichierGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SiegeSocialFichierGridDtoPaginatedResultsToJSON(value?: SiegeSocialFichierGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SiegeSocialFichierGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

